import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { validate } from 'uuid';

import { getStopoverLandingPageQueryParams } from 'modules/eurail/utils/query-params';

export function useSessionKey(): boolean {
  const SESSION_PARAM_NAME = 'sk';
  const [hasSessionKey, setHasSessionKey] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();

  const urlParams = useMemo(() => getStopoverLandingPageQueryParams(location), [location]);
  const skParam = urlParams[SESSION_PARAM_NAME];

  useEffect(() => {
    if (skParam) {
      if (validate(skParam)) {
        sessionStorage.setItem(SESSION_PARAM_NAME, skParam);
        setHasSessionKey(true);
        navigate({ pathname: location.pathname, search: '' }, { replace: true });
        return;
      } else {
        setHasSessionKey(false);
        return;
      }
    }
    // If not in URL, check sessionStorage
    const storedSk = sessionStorage.getItem(SESSION_PARAM_NAME);
    if (storedSk && validate(storedSk)) {
      setHasSessionKey(true);
    } else {
      setHasSessionKey(false);
    }
  }, [skParam, navigate, location.pathname]);

  return hasSessionKey;
}
